// src/pages/Admin/views/verification-rules/verificationRulesApi.js

import { api } from "../../../../services/apiServices"; // Adjust path to your main apiServices.js file


const VERIFICATION_RULES_BASE_URL = '/admin/verification-rules'; // <<< --- !!! PLEASE VERIFY THIS PATH !!!

// Banned Emails
export const listBannedEmails = () => api.get(`${VERIFICATION_RULES_BASE_URL}/emails`);

// Individual operations - might be deprecated in UI flow if batch handles all
export const createBannedEmail = (data) => api.post(`${VERIFICATION_RULES_BASE_URL}/emails`, data);
export const updateBannedEmail = (id, data) => api.put(`${VERIFICATION_RULES_BASE_URL}/emails/${id}`, data);
export const deleteBannedEmailApi = (id) => api.delete(`${VERIFICATION_RULES_BASE_URL}/emails/${id}`); // Renamed to avoid conflict

// New Batch Update for Banned Emails
export const batchUpdateBannedEmails = (payload) => api.put(`${VERIFICATION_RULES_BASE_URL}/emails-batch-update`, payload);

// ... (other API functions for IPs, Phones, Phrases remain the same for now)
// Banned IPs
export const listBannedIPs = () => api.get(`${VERIFICATION_RULES_BASE_URL}/ips`);
export const createBannedIP = (data) => api.post(`${VERIFICATION_RULES_BASE_URL}/ips`, data);
export const updateBannedIP = (id, data) => api.put(`${VERIFICATION_RULES_BASE_URL}/ips/${id}`, data);
export const deleteBannedIPApi = (id) => api.delete(`${VERIFICATION_RULES_BASE_URL}/ips/${id}`);
export const batchUpdateBannedIPs = (payload) => api.put(`${VERIFICATION_RULES_BASE_URL}/ips-batch-update`, payload);


// Banned Phones
export const listBannedPhones = () => api.get(`${VERIFICATION_RULES_BASE_URL}/phones`);
export const createBannedPhone = (data) => api.post(`${VERIFICATION_RULES_BASE_URL}/phones`, data);
export const updateBannedPhone = (id, data) => api.put(`${VERIFICATION_RULES_BASE_URL}/phones/${id}`, data);
export const deleteBannedPhoneApi = (id) => api.delete(`${VERIFICATION_RULES_BASE_URL}/phones/${id}`);
export const batchUpdateBannedPhones = (payload) => api.put(`${VERIFICATION_RULES_BASE_URL}/phones-batch-update`, payload);


// Banned Phrases
export const listBannedPhrases = (phraseType = null) => {
  let url = `${VERIFICATION_RULES_BASE_URL}/phrases`;
  if (phraseType) {
    url += `?phrase_type=${encodeURIComponent(phraseType)}`;
  }
  return api.get(url);
};
export const createBannedPhrase = (data) => api.post(`${VERIFICATION_RULES_BASE_URL}/phrases`, data);
export const updateBannedPhrase = (id, data) => api.put(`${VERIFICATION_RULES_BASE_URL}/phrases/${id}`, data);
export const deleteBannedPhraseApi = (id) => api.delete(`${VERIFICATION_RULES_BASE_URL}/phrases/${id}`);
export const batchUpdateBannedPhrases = (payload) => api.put(`${VERIFICATION_RULES_BASE_URL}/phrases-batch-update`, payload);